var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveysLightgray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1362 10.8214H15.4219M11.1362 16.7679H15.4219M4.5067 16.6708L5.94309 18.1071L8.33705 14.7556M4.5067 10.6172L5.94309 12.0536L8.33705 8.70201M19.6072 21.3214C19.6072 21.7761 19.4265 22.2122 19.1051 22.5336C18.7835 22.855 18.3476 23.0357 17.8929 23.0357H2.46429C2.00962 23.0357 1.57359 22.855 1.2521 22.5336C0.930612 22.2122 0.75 21.7761 0.75 21.3214V2.46429C0.75 2.00962 0.930612 1.57359 1.2521 1.2521C1.57359 0.930612 2.00962 0.75 2.46429 0.75H12.0399C12.4946 0.75 12.9306 0.930612 13.2521 1.2521L19.1051 7.10505C19.4265 7.42653 19.6072 7.86257 19.6072 8.31722V21.3214Z",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveysLightgray);
export default __webpack_public_path__ + "static/media/surveys-lightgray.72b5b928.svg";
export { ForwardRef as ReactComponent };